import { Checkbox, PrimeReactModal } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ModalFooter } from "./ModalFooter"
import { ModalLogo } from "./ModalLogo"
import { PRIME_REACT_MODAL_DEFAULT_PROPS, STATE } from "./_constants"
import { StepThreeModalProps } from "./_interfaces"

export function StepThreeModal({
  firstConfirm,
  form,
  bankSelected,
  onStepThreeConfirm,
  stepThreeData,
  setStepThreeData,
  connectingData,
  setConnectingData,
}: StepThreeModalProps) {
  const handleClose = (): void => {
    firstConfirm[STATE.SET](undefined)
    setStepThreeData(undefined)
    form[STATE.SET]({})
  }
  const filteredProducts = firstConfirm[STATE.GET]?.additionalInfo?.products
    ?.filter(
      ({ type }) =>
        type?.toLowerCase() === "card" ||
        type?.toLowerCase() === "prepaid" ||
        type?.toLowerCase() === "debit"
    )
    ?.map((product) => ({
      ...product,
      type:
        product?.type?.toLowerCase() === "prepaid"
          ? "Prepago"
          : product?.type?.toLowerCase() === "card"
          ? "Crédito"
          : "Débito",
    }))

  return (
    <PrimeReactModal
      className='tw-w-fit tw-max-w-full tw-h-fit tw-max-h-full tw-flex tw-flex-col tw-gap-2'
      ptContext={{
        dialog: PRIME_REACT_MODAL_DEFAULT_PROPS.dialog,
      }}
      header='Vincular tarjeta'
      footer={
        <ModalFooter
          onCancel={handleClose}
          onConfirm={async () => {
            try {
              setConnectingData(true)
              await onStepThreeConfirm?.({
                bankSelected,
                formData: {
                  ...form[STATE.GET],
                  accountId:
                    form[STATE.GET]?.accountId ??
                    firstConfirm[
                      STATE.GET
                    ]?.additionalInfo?.accounts?.[0]?.accountId.toString(),
                  service: bankSelected?.service ?? "",
                  products: stepThreeData ?? "",
                },
              })
            } catch (error) {
              // eslint-disable-next-line no-console
              console.error("Error connecting bank", error)
            } finally {
              setConnectingData(false)
            }
          }}
          isButtonLoading={connectingData}
          confirmButtonProps={{
            disabled: !filteredProducts?.length || !stepThreeData?.product,
            label: "Finalizar",
          }}
        />
      }
      onHide={handleClose}
      closeOnEscape
      focusOnShow={false}
      visible={Boolean(
        firstConfirm[STATE.GET]?.additionalInfo?.products?.length
      )}
    >
      <ModalLogo bankSelected={bankSelected} />
      <div className='tw-flex tw-gap-4 tw-bg-info-10 tw-border tw-border-info tw-text-info tw-py-2.5 tw-px-4 tw-rounded'>
        <FontAwesomeIcon
          icon={["fal", "info-circle"]}
          className='tw-h-6 tw-pt-0.5'
        />
        <div className='tw-flex tw-flex-col'>
          <p className='tw-leading-7'>Seleccione una tarjeta</p>
        </div>
      </div>
      <table className='tw-my-4 tw-text-neutral-800'>
        <thead>
          <tr className='tw-text-left tw-border-b tw-border-gray-300 tw-font-normal'>
            {!!filteredProducts?.length && (
              <th className='tw-font-medium tw-p-4' />
            )}
            <th className='tw-font-medium tw-p-4'>Descripción</th>
            <th className='tw-font-medium tw-p-4'>Tipo</th>
            <th className='tw-font-medium tw-p-4'>Producto</th>
            <th className='tw-font-medium tw-p-4'>Saldo</th>
          </tr>
        </thead>
        <tbody>
          {filteredProducts?.length ? (
            filteredProducts?.map((item) => (
              <tr
                key={item?.product?.toString().trim()}
                className='tw-w-full tw-text-nowrap tw-border-b tw-border-gray-300 tw-font-normal tw-cursor-pointer hover:tw-bg-gray-50 tw-transition-colors tw-duration-75 tw-ease-in-out'
                onClick={() => {
                  setStepThreeData((prevData) =>
                    prevData?.product === item.product ? undefined : item
                  )
                }}
              >
                <td className='tw-py-4 tw-px-4 tw-text-left'>
                  <Checkbox
                    isChecked={item?.product === stepThreeData?.product}
                    className='tw-bg-white'
                  />
                </td>
                <td className='tw-py-4 tw-px-4 tw-text-left'>
                  {item?.description}
                </td>
                <td className='tw-py-4 tw-px-4 tw-text-left'>{item?.type}</td>
                <td className='tw-py-4 tw-px-4 tw-text-left'>
                  {item?.product}
                </td>
                <td className='tw-py-4 tw-px-4 tw-text-right'>
                  {Intl.NumberFormat("de-DE", {
                    style: "currency",
                    currency: item?.currency?.replace("$", "") ?? "EUR",
                  }).format(Number(item?.balance ?? 0))}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                className='tw-px-4 tw-pt-4 tw-text-center'
                colSpan={4}
              >
                Sin productos disponibles
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </PrimeReactModal>
  )
}
